<div class="air-details-container">

  <p class="shoutBorder">
    <strong>OERI Last Called TLR: </strong>{{ oeriStatistics.lastCalled }}
    <strong>Installed TLR's Provided to OERI:</strong>
    {{ oeriStatistics.openTlr }}
    <strong> TLR's Removed in the Last 30 Days: </strong
    >{{ oeriStatistics.removedIn30days }}
  </p>
  <div class="section-title">Match OERI Open TLR's Details</div>

  <div>
    <div class="table-chart-container mt-10">
      <div class="exportToExcel excel-btn">
        <div class="actions">
          <button
            pButton
            type="button"
            label="Export To Excel"
            icon="pi pi-file-excel"
            class="btn-primary"
            (click)="exportToExcel()"
          >
            Export To Excel
          </button>
        </div>
      </div>
      <p-table
        [value]="oeriData"
        paginator="true"
        [rows]="25"
        responsiveLayout="scroll"
        styleClass="p-datatable-gridlines"
        id="StyleTable"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Tag Number</th>
            <th>Entry Date</th>
            <th>Op. User ID</th>
            <th>Division</th>
            <th>Section</th>
            <th>Plant</th>
            <th>LDAR</th>
            <th>Op. PSI</th>
            <th>Op. Temp</th>
            <th>Shutdown Description</th>
            <th>Service</th>
            <th>Insp. User ID</th>
            <th>Service Class</th>
            <th>OA User ID</th>
            <th>Permanent Repair Date</th>
            <th>Eng. User ID</th>
            <th>TLR Type</th>
            <th>Maximo WO Number</th>
            <th>Maximo Outage-T/A</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr let data of reportData>
            <td (click)="details(data)" class="linkUnderline">
              {{ data.Tag_Number }}
            </td>
            <td>{{ data.Data_Entry_Date | date : "M/d/yyyy" }}</td>
            <td>{{ data.Operator_CAI }}</td>
            <td>{{ data.Division }}</td>
            <td>{{ data.Section }}</td>
            <td>{{ data.Plant }}</td>
            <td>{{ data.LDAR }}</td>
            <td>{{ data.Oper_PSI }}</td>
            <td>{{ data.Oper_Temp }}</td>
            <td>{{ data.ShutdownDescription }}</td>
            <td>{{ data.Service }}</td>
            <td>{{ data.InspectionCAI }}</td>
            <td>{{ data.ServiceClass }}</td>
            <td>{{ data.OACAI }}</td>
            <td [ngClass]="getDateClass(data.Permanent_Repair_Date)">
              {{ data.Permanent_Repair_Date  | date : "M/d/yyyy" }}
            </td>
            <td>{{ data.EngineeringCAI }}</td>
            <td>{{ data.TLRType }}</td>
            <td>{{ data.Maximo_WO_Number }}</td>
            <td>{{ data.Maximo_Outage_T_A }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
